<template>
    <div id="app">
        <router-view></router-view>
        <vue-progress-bar></vue-progress-bar>
    </div>
</template>
<script>
export default {
  name: 'app'
}
</script>
<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Kanit:400,700&subset=latin-ext,thai,vietnamese');
  @import '~flag-icon-css/css/flag-icon.min.css';
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import 'assets/fontawesome/css/all.min.css';
  @import 'assets/scss/style';
</style>